import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// Bridge pair: bridge--logout ↔ LogoutComponent (iOS).
//
// Rendered as a hidden element on the page that follows a successful
// DELETE /sessions/:id. Fires once on connect, telling native to wipe
// WebView cookies + Keychain auth artefacts and restart the navigator.
// Without it, sign-out leaves residual session state on shared devices.
//
// Browser (no native bridge): `enabled` is false and connect is a no-op.
export default class extends BridgeComponent {
  static component = "logout"

  connect() {
    super.connect()
    this.#purgeWhenReady(0)
  }

  // Sign-out is often triggered from the Settings MODAL — a separate, freshly
  // activated WebView session whose bridge may not have finished advertising
  // its components at the moment this element connects. `this.enabled` is then
  // false, and a single early `return` drops the purge silently: native never
  // restarts and the app is stuck on onboarding-in-modal. Retry on the next
  // frames until the bridge is ready, then send once. In a real browser (no
  // native bridge) `enabled` never flips true and we give up after the cap —
  // a harmless no-op, same as before.
  #purgeWhenReady(attempt) {
    if (this.enabled) {
      this.send("purge", {}, () => {})
      return
    }
    if (attempt >= 60) return
    requestAnimationFrame(() => this.#purgeWhenReady(attempt + 1))
  }
}
